export const planesData = {
  combos: [
    {
      id: 'minicombi',
      name: 'Plan Inicio',
      price: '$350',
      period: '/mes',
      subtitle: '4 Videos + 4 Artes al Mes',
      description: 'Ideal para pequeñas empresas que quieren empezar con todo. Incluye 1 grabación mensual y 1 ronda de cambios.',
      popular: false,
    },
    {
      id: 'combimediana',
      name: 'Plan Emprendedor',
      price: '$450',
      period: '/mes',
      subtitle: '8 Videos + 8 Artes al Mes',
      description: 'Ideal para marcas que buscan crecer y destacar. Incluye 2 grabaciones mensuales y 2 rondas de cambios.',
      popular: true,
    },
    {
      id: 'supercombi',
      name: 'Plan Ultra',
      price: '$600',
      period: '/mes',
      subtitle: '12 Videos + 12 Artes al Mes',
      description: 'Ideal para marcas que buscan llevar su contenido al siguiente nivel. Incluye 4 grabaciones mensuales y 2 rondas de cambios.',
      popular: false,
    },
  ],
  diseno: [
    {
      id: 'mini',
      name: 'Plan Inicio',
      price: '$80',
      period: '/mes',
      subtitle: '4 Artes al Mes',
      description: 'Ideal para marcas que están comenzando. Incluye diseño, entrega final y 1 ronda de cambios por arte.',
      popular: false,
    },
    {
      id: 'gmedia',
      name: 'Plan Emprendedor',
      price: '$150',
      period: '/mes',
      subtitle: '8 Artes al Mes',
      description: 'Para marcas establecidas que buscan elevar su imagen. Incluye 1 ronda de cambios por arte.',
      popular: true,
    },
    {
      id: 'multi',
      name: 'Plan Ultra',
      price: '$200',
      period: '/mes',
      subtitle: '12 Artes al Mes',
      description: 'Incluye edición, entrega final y 2 rondas de cambios por arte.',
      popular: false,
    },
  ],
  contenido: [
    {
      id: 'babymovie',
      name: 'Plan Inicio',
      price: '$250',
      period: '/mes',
      subtitle: '4 Videos Entregables al Mes',
      description: 'Incluye 1 jornada de grabación mensual, edición, entrega final y 1 ronda de cambios por video.',
      popular: false,
    },
    {
      id: 'mediamovie',
      name: 'Plan Emprendedor',
      price: '$350',
      period: '/mes',
      subtitle: '8 Videos Entregables al Mes',
      description: 'Incluye hasta 2 jornadas de grabación mensuales, edición, entrega final y hasta 2 rondas de cambios por video.',
      popular: true,
    },
    {
      id: 'supermovie',
      name: 'Plan Ultra',
      price: '$500',
      period: '/mes',
      subtitle: '12 Videos Entregables al Mes',
      description: 'Incluye hasta un máximo de 4 jornadas de grabación mensuales, edición, entrega final y hasta 2 rondas de cambios por video.',
      popular: false,
    },
  ],
  combiCompleta: [
    {
      id: 'combicompleta',
      name: 'Plan Manejo de Redes',
      price: '$750',
      period: '/mes',
      subtitle: 'Manejo de tus Redes Sociales',
      description: 'Nuestra opción más completa para que no tengas que preocuparte por nada. Incluye creación de contenido, diseño gráfico, producción audiovisual y escenográfica, además del manejo de tus redes sociales para mantener tu marca activa y con contenido constante.',
      popular: true,
    },
  ],
  logo: [
    {
      id: 'logobasico',
      name: 'Logo Básico',
      price: '$150',
      period: '',
      subtitle: 'Versión positivo y negativo',
      description: 'Diseño de logo base, versión positivo y negativo, paleta de colores y archivo Illustrator.',
      popular: false,
    },
    {
      id: 'logopro',
      name: 'Logo Pro',
      price: '$250',
      period: '',
      subtitle: '2 variantes de logo',
      description: 'Diseño de logo con 2 variantes, versión positivo y negativo, paleta de colores y archivo Illustrator.',
      popular: true,
    },
    {
      id: 'identidad',
      name: 'Identidad Visual',
      price: '$500',
      period: '',
      subtitle: 'Manual de marca completo',
      description: 'Logotipo, paleta de colores, tipografía corporativa, imagenería, aplicaciones visuales, isotipo, imagotipo, retícula y manual de marca.',
      popular: false,
    },
  ],
};
